var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d926e2cba89f912b9703b9f65001e6b38fb7c7c0"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["vardhan-ui@rapidcanvas"]={id:"d926e2cba89f912b9703b9f65001e6b38fb7c7c0"};
      